/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q7_AnswerInputs */

const en_home_faq_q7_answer = /** @type {(inputs: Home_Faq_Q7_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activating your account allows you to manage your policy, access support, submit claims, and connect with resources designed to support you before, during, and after travel.`)
};

const fr_home_faq_q7_answer = /** @type {(inputs: Home_Faq_Q7_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'activation de votre compte vous permet de gérer votre police, d'accéder au soutien, de soumettre des réclamations et de vous connecter aux ressources conçues pour vous soutenir avant, pendant et après le voyage.`)
};

/**
* | output |
* | --- |
* | "Activating your account allows you to manage your policy, access support, submit claims, and connect with resources designed to support you before, during, a..." |
*
* @param {Home_Faq_Q7_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q7_answer = /** @type {((inputs?: Home_Faq_Q7_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q7_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q7_answer(inputs)
	return fr_home_faq_q7_answer(inputs)
});